module.exports = __webpack_public_path__ + "static/media/bio-user.4229f6eb.svg";